import apiClient from '@/api/index'

export default {
  index (params) {
    return apiClient.get('/site-versions', { params })
  },
  store (formData) {
    return apiClient.post('/site-versions', formData)
  },
  show (id, params) {
    return apiClient.get(`/site-versions/${id}`, { params })
  },
  update (id, formData) {
    formData.append('_method', 'PUT')
    return apiClient.post(`/site-versions/${id}`, formData)
  },
  destroy (id) {
    return apiClient.delete(`/site-versions/${id}`)
  }
}
